import React from "react";

export const knight_outline = (stroke) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24.037"
        height="24.025"
        viewBox="0 0 24.037 24.025"
    >
        <path
            id="path3827"
            d="M7.485,22.987c-2.092-.045-2.8-.126-2.921-.337a5.769,5.769,0,0,1,.484-2.423c.688-1.846,1.833-3.642,2.618-4.108a1.532,1.532,0,0,1,.476-.175A2.4,2.4,0,0,0,9.265,15.3a2.984,2.984,0,0,1,2.05-.758,5.668,5.668,0,0,0,2.709-.852,6.463,6.463,0,0,0,1.344-1.172,4.815,4.815,0,0,0,.723-1.339,3.464,3.464,0,0,0,.12-1.261c0-.911-.014-.981-.211-.982a8.665,8.665,0,0,0-.647,1.056,8.314,8.314,0,0,1-1.61,2.265c-.91.815-1.969,1.107-4.217,1.166-2.6.068-2.669.1-4.2,1.737L4.9,15.62l-1.268-.685L2.29,14.209c-.058-.03-.016-.078.183-.2,1.084-.676,1.226-.813,1.1-1.06a1.393,1.393,0,0,0-.942-.31,1.214,1.214,0,0,0-.853.3,1.1,1.1,0,0,1-.491.275c-.03,0-.092-.112-.143-.249a6.914,6.914,0,0,1-.111-1.743l-.022-1.5,1.023-.617C4.552,7.587,6.143,6.554,7.3,5.683a31.492,31.492,0,0,1,2.814-1.855,10.43,10.43,0,0,0,2.933-2.3c.458-.55.587-.614.815-.367a3.67,3.67,0,0,1,.393.707c.492,1.1,1.1,1.691,2.809,2.71a13.157,13.157,0,0,1,3.749,3.271,6.321,6.321,0,0,1,1.235,2.584,30.318,30.318,0,0,1,.348,4.9c0,2.057.131,4.953.268,6a16.336,16.336,0,0,0,.348,1.625c.026.079-.328.083-6.939.075-3.831,0-7.694-.023-8.584-.042Z"
            transform="translate(-0.003 -0.008)"
            stroke={stroke}
            strokeWidth="1"
        />
    </svg>
);
